// The browser has no native API to learn its own public/external IP (unlike
// server-side code, which just reads the raw socket) — brunix-proxy-local-edge.js
// solves the same problem server-side by asking a public echo service
// (api.ipify.org). This does the same thing from the frontend.
let cachedOwnExternalIp: string | null = null;
let inFlight: Promise<string> | null = null;

/**
 * Resolves the browser's own public/external IP. Cached after the first
 * successful resolution for the lifetime of the page (it isn't going to
 * change mid-session) — concurrent callers before that share the same
 * in-flight request instead of each firing their own.
 */
export const getOwnExternalIp = async (): Promise<string> => {
  if (cachedOwnExternalIp) return cachedOwnExternalIp;
  if (!inFlight) {
    inFlight = (async () => {
      try {
        const res = await fetch('https://api.ipify.org?format=json');
        const data = await res.json();
        if (data?.ip) cachedOwnExternalIp = data.ip;
        return cachedOwnExternalIp ?? 'unknown (ipify returned no ip)';
      } catch (err) {
        return `unknown (error: ${err?.message ?? err})`;
      } finally {
        inFlight = null;
      }
    })();
  }
  return inFlight;
};
